interface AddonCounter {
  clipArtId: string; // Changed to string to support UUIDs
  quantity: number;
}

const calculateUsedClipArtHash = (usedClipArts: AddonCounter[]): string => {
  const sortedClipArts = usedClipArts.sort((a: AddonCounter, b: AddonCounter) => {
    // Compare as strings to handle both numeric IDs and UUIDs
    if (a.clipArtId < b.clipArtId) return -1;
    if (a.clipArtId > b.clipArtId) return 1;
    return 0;
  });
  return JSON.stringify(sortedClipArts.map((ca) => `${ca.clipArtId}_${ca.quantity}`));
};

export default calculateUsedClipArtHash;
